// Smoothly scrolls to a section using the active Lenis instance when
// available, falling back to native scroll for reduced-motion users.
export function scrollToSection(id, offset = -72) {
  const target = document.getElementById(id);
  if (!target) return;

  if (window.__lenis) {
    window.__lenis.scrollTo(target, { offset, duration: 1.3 });
  } else {
    const top = target.getBoundingClientRect().top + window.scrollY + offset;
    window.scrollTo({ top, behavior: "smooth" });
  }
}
